import { Accordion } from '@repo/design-system-kit/components/accordion/accordion';
import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';
import { Popup } from '@repo/design-system-kit/components/popup/popup';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import generalScaApprovalAnimation from '@repo/visual-assets/dotlottie/lottie_cp_general_sca_approval.lottie';
import { useFaqService } from '../../../utils/faq-composer';
import styles from './sca.module.css';

interface WaitingProps {
  onClose?: () => void;
}

export function Waiting({ onClose }: WaitingProps): React.ReactNode {
  const faqService = useFaqService();
  const [isOpen, setIsOpen] = useState(true);
  const { formatMessage } = useIntl();
  const handleClose = (): void => {
    setIsOpen(false);
    onClose?.();
  };

  return (
    <Popup.Root
      aria-label={formatMessage({ id: 'sca.sensitive-actions.generic.confirm.title' })}
      data-testid="sca-waiting-popup"
      isOpen={isOpen}
      role="dialog"
    >
      <Popup.CloseButton onPress={handleClose} />
      <Popup.Header>
        <figure aria-hidden className={styles.illustrationWrap}>
          <LottiePlayer data-img="sms-animation" loop src={generalScaApprovalAnimation} />
        </figure>
        <Popup.Title>
          <FormattedMessage id="sca.sensitive-actions.generic.confirm.title" />
        </Popup.Title>
        <Popup.Subtitle>
          <FormattedMessage id="sca.sensitive-actions.generic.confirm.subtitle" />
        </Popup.Subtitle>
      </Popup.Header>
      <Popup.Body>
        <Accordion.Group>
          <Accordion.Single
            className="mb-20"
            title={formatMessage({ id: 'sca.sensitive-actions.accordion.no-notification.title' })}
          >
            <p className="body-standard">
              <FormattedMessage id="sca.sensitive-actions.accordion.no-notification.subtitle" />
            </p>
          </Accordion.Single>
          <Accordion.Single
            className="mb-20"
            title={formatMessage({ id: 'sca.sensitive-actions.accordion.no-phone.title' })}
          >
            <p className="body-standard">
              <FormattedMessage
                id="sca.sensitive-actions.accordion.no-phone.subtitle"
                values={{
                  a: (chunks: React.ReactNode) => (
                    <a
                      className={styles.faqLink}
                      href={faqService.getLocalizedArticle('how_to_pair_my_phone')}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {chunks}
                    </a>
                  ),
                  br: () => <br />,
                }}
              />
            </p>
          </Accordion.Single>
        </Accordion.Group>
      </Popup.Body>
    </Popup.Root>
  );
}
